import { memo, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { TextField } from "@material-ui/core";
import React from "react";
import { Countries } from "../../../assets/json/countries";
import { GolContactCountryAutoComplete } from "./gol-contact-form-interfaces";
import GolAutocomplete from "./gol-autocomplete";
import styled from "styled-components";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { AutocompleteRenderInputParams } from "@mui/material";
export interface Country {
  code: string;
  label: string;
  phone: string;
}

const AutocompleteWrapper = styled.div`
  display: flex;

  [class*="MuiOutlinedInput-root"] {
    height: 40px;
  }

  input#country-picker {
    font-size: 14px;
  }
`;

const CustomField = styled.div`
  font-size: 14px;
`;

const CustomErrorField = styled(TextField)`
  &.error {
    fieldset {
      border-color: ${(props) => props.theme.error};
    }

    p.Mui-required {
      color: ${(props) => props.theme.error};
      margin-top: 0;
    }
  }
`;
const GolCountryPicker = (props: GolContactCountryAutoComplete) => {
  const [country, setCountry] = useState<undefined | Country | string>(
    props.defaultValue
  );
  useEffect(() => {
    setCountry(props.defaultValue);
  }, [props]);
  const { t } = useTranslation();
  const handleSelectCountry = (
    event: any,
    value: {
      code: string;
      label: string;
      phone: string;
    }
  ) => {
    if (typeof value != "string") {
      setCountry({
        code: value.code,
        label: value.label,
        phone: value.phone,
      } as Country);
      props.onChange({ target: { name: props.name, value: value } });
    }
  };
  const renderOptionCountry = (option: Country, props: any) => (
    <Box
      component="div"
      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
      {...props}
    >
      <img
        loading="lazy"
        width="20"
        src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
        srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
        alt=""
      />
      {option.label} ({option.code})
    </Box>
  );
  const renderOptionCountryCode = (option: Country) => (
    <CustomField>
      <ReactCountryFlag countryCode={option.code} svg /> {option.label} +
      {option.phone}
    </CustomField>
  );
  const renderInputCountryCode = (params: AutocompleteRenderInputParams) => (
    <CustomErrorField
      {...params}
      name={"defaultCountry"}
      label={t("instabook.contacts.prefix")}
      className={props.defaultCountryError ? "error" : ""}
      variant={"outlined" as any}
      required={true}
      inputProps={{
        ...params.inputProps,
        // autoComplete: 'new-password', // disable autocomplete and autofill
      }}
    />
  );
  const renderInputCountry = (params: AutocompleteRenderInputParams) => (
    <TextField
      name="country-picker"
      {...params}
      variant={"outlined" as any}
      fullWidth={true}
      label={props.label}
      inputProps={{
        ...params.inputProps,
        autoComplete: "new-password", // disable autocomplete and autofill
      }}
    />
  );
  const renderInput =
    props.name == "country" ? renderInputCountry : renderInputCountryCode;
  const renderOption =
    props.name === "country" ? renderOptionCountry : renderOptionCountryCode;
  return (
    <AutocompleteWrapper className={props.claszName ?? ""}>
      <GolAutocomplete
        id={props.id}
        classes={props.classes}
        value={country}
        onChange={handleSelectCountry}
        getOptionLabel={props.getOptionLabel}
        options={Countries}
        renderOption={renderOption}
        renderInput={renderInput}
      />
    </AutocompleteWrapper>
  );
};

export default memo(GolCountryPicker);
